// this is the dynamic forms from marketing hub
import { useGetForm } from "@/react/components/SettingsApp/Emails/components/Forms/hooks/useGetForm";
import type {
  FormEmbedDisplayFormat,
  Form as FormType,
} from "@/react/types/Form";
import { FormContent } from "./FormContent";
import { ShowModal } from "./ShowModal";
import { useAdjustFormHeight } from "./hooks/useAdjustFormHeight";

interface FormRendererProps {
  embedDisplayFormat?: FormEmbedDisplayFormat;
  form?: FormType;
  id?: number;
  index: number;
  isPreview?: boolean;
  isUsedOnPages?: boolean;
  popupDelay?: number;
  popupFrequency?: number;
}

export const FormRenderer = ({
  id,
  index,
  form,
  isPreview = false,
  isUsedOnPages = false,
  embedDisplayFormat,
  popupFrequency,
  popupDelay,
}: FormRendererProps) => {
  const { data: fetchedForm, isLoading } = useGetForm({ id });
  const usedForm = fetchedForm || form;
  const formDisplayFormat = isUsedOnPages
    ? "inline"
    : (embedDisplayFormat ?? usedForm?.embed_display_format);
  const isModal = formDisplayFormat === "popup";
  const DisplayFormComponent = isModal ? ShowModal : FormContent;

  useAdjustFormHeight({ form: usedForm, index, isModal });

  if (isLoading || !usedForm || !usedForm.elements) {
    return null;
  }

  return (
    <DisplayFormComponent
      form={usedForm}
      formElements={usedForm.elements}
      isPreview={isPreview}
      isModal={isModal}
      isUsedOnPages={isUsedOnPages}
      popupDelay={popupDelay ?? usedForm.popup_delay}
      popupFrequency={popupFrequency ?? usedForm.popup_frequency}
      backgroundColor={usedForm.background_color}
      textColor={usedForm.text_color}
      index={index}
    />
  );
};
